import { render } from "./PanelAbstracts.vue?vue&type=template&id=346472d6&scoped=true&ts=true"
import script from "./PanelAbstracts.vue?vue&type=script&lang=ts"
export * from "./PanelAbstracts.vue?vue&type=script&lang=ts"

import "./PanelAbstracts.vue?vue&type=style&index=0&id=346472d6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346472d6"]])

export default __exports__